import React, { Component } from 'react';
import PropTypes from 'prop-types';
import UnexpectedErrorPage from '../ErrorPages/UnexpectedErrorPage';
import { isProduction } from '../Utils/environment';

/**
Isola eventuali eccezioni javascript evitando al visualizzazione di una pagina bianca, mostrando un messaggio di errore user-friendly.
Integrato di default all'interno del componente Sidebar.Body.
 */
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      errorInfo: null,
      showDetails: !isProduction(),
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { toggleShow } = this.props;

    if (nextProps.toggleShow !== toggleShow) {
      this.setState({
        error: null,
        errorInfo: null,
      });
    }
  }

  componentDidCatch(error, errorInfo) {
    const { onCatch } = this.props;
    this.setState({
      error,
      errorInfo,
    }, () => {
      if (typeof onCatch === 'function') {
        onCatch(error, errorInfo);
      }
    });
  }

  // api pubblica
  // eslint-disable-next-line react/no-unused-class-component-methods
  resetErrors = () => {
    this.setState({
      error: null,
      errorInfo: null,
    });
  };

  render() {
    const { children, errorTitle } = this.props;
    const { error, errorInfo, showDetails } = this.state;
    if (errorInfo && !errorTitle) return <UnexpectedErrorPage />;
    return errorInfo
      ? (
        <div className="errorBoundary">
          <div className="errorBoundary__content">
            {errorTitle}
            {showDetails && (
              <details className="errorDetails">
                {error && error.toString()}
                <br />
                {errorInfo.componentStack}
              </details>
            )}
          </div>
        </div>
      ) : children;
  }
}

ErrorBoundary.propTypes = {
  /**
     * Componente da renderizzare gestito in caso di errore
     */
  children: PropTypes.node.isRequired,
  /**
     * Renderizza un titolo personalizzato
     */
  errorTitle: PropTypes.node,
  /**
   * Callback invocata in caso di eccezione:
   * ```
   *  onCatch(error, errorInfo)
   * ```
   * dove:
   * * *error*: errore scatenato
   * * *errorInfo*: contiene il componentStack con lo stack dell'errore
   */
  onCatch: PropTypes.func,
  /**
     * Forza toggle
     */
  toggleShow: PropTypes.bool,
};

ErrorBoundary.defaultProps = {
  errorTitle: null,
  onCatch: null,
  toggleShow: false,
};

export default ErrorBoundary;
